import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import { Headers } from '@angular/http';
import { Deferred } from 'prophecy/src/Deferred';
import { Credentials } from '../app/credentials';
import { MessageService } from '../app/message.service';
import { CredentialsService } from '../app/credentials.service';
import { DatastoreService } from '../app/datastore.service';

// ionic serve
// api is proxied
// var apiUrl = '/api';

// TODO: proxy to this from <hub URL>/api in Cloudfront?

//FIXME: config?
// maybe like this? https://stackoverflow.com/q/39576991
// var apiUrl = 'https://h053l5ffci.execute-api.ap-southeast-2.amazonaws.com/dev';
// var apiUrl = 'https://iiczor16vf.execute-api.us-east-2.amazonaws.com/dev';
// BtP dev (note this is misnamed "test"):
// var apiUrl = 'https://u4qvgg3sr1.execute-api.us-east-2.amazonaws.com/test';
// BtP test:
// var apiUrl = 'https://6rstf90us6.execute-api.us-east-2.amazonaws.com/test';
// BtP produs
var apiUrl = 'https://pqml2wa055.execute-api.us-east-2.amazonaws.com/prod';

declare var pako;
const MaxRecordsPerChunk = 5000;


@Injectable()
export class HubService {

  credentials: Credentials;
  viewDownloadPromises;
  projectShortName;

  constructor(
    public http: Http,
    private alertCtrl: AlertController,
    private messageService: MessageService,
    private datastoreService: DatastoreService,
    private credentialsService: CredentialsService) {
    this.viewDownloadPromises = {};
    this.projectShortName = window.localStorage.getItem('project_short_name');
  }

  couldNotAuthenticate() {
    let alert = this.alertCtrl.create({
      title: 'Could not connect to server',
      subTitle: 'Please check your credentials and that you are on-line.',
      buttons: ['Dismiss']
    });
    alert.present();
  }

  uncompress(base64data) {
    var compressData = atob(base64data);
    var compressDataArray = compressData.split('').map(function(e) {
        return e.charCodeAt(0);
    });
    var binData = new Uint8Array(compressDataArray);
    var data = pako.inflate(binData);
    var uArray = new Uint16Array(data);
    var resultString = ''
    for (var idx = 0; idx < uArray.length; ++idx) {
      resultString += String.fromCharCode(uArray[idx]);
    }
    return resultString;
  }

  deletePivotOnServer(pivotId) {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        // console.log('pivotName=', pivotName);
        this.http.post(apiUrl + '/hubpost', {
            'op': 'deletePivot',
            'projectShortName': this.projectShortName,
            'email': this.credentials.email,
            'pivotId': pivotId,
          }, {headers: headers}).subscribe(data => {
          // console.log('data=', data);
          deferredPromise.resolve('OK');
        });
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  deleteDashboardOnServer(dashboardId) {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        // console.log('pivotName=', pivotName);
        this.http.post(apiUrl + '/hubpost', {
            'op': 'deleteDashboard',
            'projectShortName': this.projectShortName,
            'email': this.credentials.email,
            'dashboardId': dashboardId,
          }, {headers: headers}).subscribe(data => {
          // console.log('data=', data);
          deferredPromise.resolve('OK');
        });
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  saveDashboardToServer(dashboardId, dashboardName, dashboardDescription, dashboardPageNames, pivotIds) {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        // console.log('pivotName=', pivotName);
        this.http.post(apiUrl + '/hubpost', {
            'op': (dashboardId < 0 ? 'saveNewDashboard' : 'saveDashboard'),
            'projectShortName': this.projectShortName,
            'email': this.credentials.email,
            'dashboardName': dashboardName,
            'dashboardDescription': dashboardDescription,
            'dashboardPageNames': dashboardPageNames,
            'dashboardId': dashboardId,
            'pivotIds': pivotIds
          }, {headers: headers}).subscribe(data => {
          // console.log('data=', data);
          deferredPromise.resolve('OK');
        });
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  savePivotToServer(pivotId, viewId, pivotName, pivotDescription, widgetConfig) {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        // console.log('pivotName=', pivotName);
        this.http.post(apiUrl + '/hubpost', {
            'op': (pivotId < 0 ? 'saveNewPivot' : 'savePivot'),
            'projectShortName': this.projectShortName,
            'email': this.credentials.email,
            'pivotName': pivotName,
            'pivotDescription': pivotDescription,
            'pivotId': pivotId,
            'pivotViewId': viewId,
            'pivotConfig': widgetConfig
          }, {headers: headers}).subscribe(data => {
          // console.log('data=', data);
          deferredPromise.resolve('OK');
        });
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  saveUserSettings() {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        this.http.post(apiUrl + '/hubpost', {
            'op': 'saveUserSettings',
            'projectShortName': this.projectShortName,
            'email': this.credentials.email,
            'settings': JSON.stringify(this.credentials.settings),
          }, {headers: headers}).subscribe(data => {
          // console.log('data=', data);
          deferredPromise.resolve('OK');
        });
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  getUserSettings() {
    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        this.http.get(apiUrl + '/hubget', {
          headers: headers,
          params: {
            op: 'getUserSettings',
            projectShortName: this.projectShortName,
            var1: '',
            var2: '',
            var3: ''}}).subscribe(data => {
            // console.log('getPivotListForUser data=', data);
            var result = data.text();
            let uncompressedJson = this.uncompress(result);
            console.log(JSON.parse(uncompressedJson));
            try {
              this.credentials.settings = JSON.parse(uncompressedJson);
              deferredPromise.resolve('OK');
            }
            catch(error) {
              let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'You are not set up correctly on the server - contact Work@Scale support.',
                buttons: [{
                  text: 'Dismiss',
                  handler: () => {
                    deferredPromise.resolve('Error on authenticating - not on server.');
                  }
                }]
              });
              alert.present();
            }
          }
        );
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  getDashboardListForUser() {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        this.http.get(apiUrl + '/hubget', {
          headers: headers,
          params: {
            op: 'getDashboardListForUser',
            projectShortName: this.projectShortName,
            var1: '',
            var2: '',
            var3: ''}}).subscribe(data => {
            if (data.text() !== '') {
              // console.log('getPivotListForUser data=', data);
              var result = data.text();
              let uncompressedJson = this.uncompress(result);
              console.log(JSON.parse(uncompressedJson));
              this.datastoreService.set('dashboardListForUser', uncompressedJson).then(() => {
                deferredPromise.resolve('OK');
              })
            }
            else {
              deferredPromise.resolve('OK');
            }
          }
        );
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  getPivotListForUser() {
    this.credentials = this.credentialsService.getCredentials();
    // console.log(this.credentials);

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        this.http.get(apiUrl + '/hubget', {
          headers: headers,
          params: {
            op: 'getPivotListForUser',
            projectShortName: this.projectShortName,
            var1: '',
            var2: '',
            var3: ''}}).subscribe(data => {
            // console.log('getPivotListForUser data=', data);
            var result = data.text();
            let uncompressedJson = this.uncompress(result);
            // console.log(JSON.parse(uncompressedJson));
            this.datastoreService.set('pivotListForUser', uncompressedJson);
            deferredPromise.resolve('OK');
          }
        );
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  getViewListForUser() {
    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        this.http.get(apiUrl + '/hubget', {
          headers: headers,
          params: {
            op: 'getViewListForUser',
            projectShortName: this.projectShortName,
            var1: '',
            var2: '',
            var3: ''}}).subscribe(data => {
            // console.log('getViewListForUser data=', data);
            var result = data.text();
            let uncompressedJson = this.uncompress(result);
            // console.log(JSON.parse(uncompressedJson));
            this.datastoreService.set('viewListForUser', uncompressedJson);
            deferredPromise.resolve('OK');
          }
        );
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    return deferredPromise.promise;
  }

  getViewData(viewId) {
    if (viewId.toString() in this.viewDownloadPromises) {
      console.log('this.viewDownloadPromises[viewId.toString()]=', this.viewDownloadPromises[viewId.toString()]);
      return this.viewDownloadPromises[viewId.toString()];
    }

    let deferredPromise = new Deferred();
    this.credentialsService.getCredentials().then((data) => {
      this.credentials = data;
      if (this.credentials !== undefined && this.credentials.idToken !== null && this.credentials.idToken !== '') {
        let headers: Headers = new Headers;
        headers.append('Authorization', this.credentials.idToken);
        // console.log('headers=', headers);
        this.http.get(apiUrl + '/hubget', {
          headers: headers,
          params: {
            op: 'getViewDataNumberOfRecords',
            projectShortName: this.projectShortName,
            var1: viewId.toString(),
            var2: '',
            var3: ''}}).subscribe(
            data => {
            // console.log('getViewData data=', data);
            var result = data.text();
            let uncompressedJson = this.uncompress(result);
            // console.log('uncompressedJson=', uncompressedJson);
            let records = JSON.parse(uncompressedJson)[0][0];
            // console.log('_get_view_data_number_of_records=', JSON.parse(uncompressedJson));
            // console.log('MaxRecordsPerChunk=', MaxRecordsPerChunk);
            let deferredPromiseChain = [];
            for (let chunkIndex = 0; chunkIndex < Math.floor(records/MaxRecordsPerChunk) + 1; ++chunkIndex) {
              let deferredPromiseForChunk = new Deferred();
              deferredPromiseChain.push(deferredPromiseForChunk);
            }

            this.http.get(apiUrl + '/hubget', {
              headers: headers,
              params: {
                  op: 'getViewDataPortion',
                  projectShortName: this.projectShortName,
                  var1: viewId.toString(),
                  var2: 0 * MaxRecordsPerChunk,
                  var3: MaxRecordsPerChunk.toString()}}).subscribe(data => {
                // console.log('getViewData data=', data);
                var result = data.text();
                let uncompressedJson = this.uncompress(result);
                // console.log(JSON.parse(uncompressedJson));
                this.datastoreService.set('viewData:' + viewId.toString() + ':' + (0).toString(),
                  uncompressedJson).then(() => {
                    deferredPromiseChain[0].resolve('Stored View Data Chunk');
                });
              }
            );

            let chunksToDownload = deferredPromiseChain.length;
            let deferredPromiseChainToDo = deferredPromiseChain.length;
            if (deferredPromiseChain.length > 0) {
              this.messageService.sendMessage('[HubService]Downloading data from server (' +
                (chunksToDownload - deferredPromiseChain.length + 1).toString() + ' of ' +
                chunksToDownload.toString() + ' chunks)');
              for (let defIdx = 0; defIdx < deferredPromiseChain.length; ++defIdx) {
                deferredPromiseChain[defIdx].promise.then((result)=> {
                  // console.log('promise result:', result);
                  deferredPromiseChainToDo -= 1;
                  this.messageService.sendMessage('[HubService]Downloading data from server (' +
                    (chunksToDownload - deferredPromiseChainToDo).toString() + ' of ' +
                    chunksToDownload.toString() + ' chunks)');
                  // console.log('deferredPromiseChainToDo=', deferredPromiseChainToDo);
                  this.http.get(apiUrl + '/hubget', {
                    headers: headers,
                    params: {
                        op: 'getViewDataPortion',
                        projectShortName: this.projectShortName,
                        var1: viewId.toString(),
                        var2: defIdx * MaxRecordsPerChunk,
                        var3: MaxRecordsPerChunk.toString()}}).subscribe(data => {
                      // console.log('getViewData data=', data);
                      var result = data.text();
                      let uncompressedJson = this.uncompress(result);
                      // console.log(JSON.parse(uncompressedJson));
                      this.datastoreService.set('viewData:' + viewId.toString() + ':' + defIdx.toString(),
                        uncompressedJson).then(() => {
                        if (deferredPromiseChainToDo === 0) {
                          // All done
                          deferredPromise.resolve('OK');
                        }
                        if (defIdx + 1 < deferredPromiseChain.length) {
                          deferredPromiseChain[defIdx + 1].resolve('Stored View Data Chunk');
                        }
                      });
                    }
                  );
                })
              }
            }
          }
        );
      }
      else {
        this.couldNotAuthenticate();
        deferredPromise.resolve('Error on authenticating.');
      }
    });
    this.viewDownloadPromises[viewId.toString()] =
      deferredPromise.promise.then(() => {
        delete this.viewDownloadPromises[viewId.toString()];
      });
    return deferredPromise.promise;
  }

}



// WEBPACK FOOTER //
// ./src/app/hub.service.ts